import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "summary-books" }
const _hoisted_2 = { class: "summary-books__covers" }
const _hoisted_3 = ["src"]


export default /*@__PURE__*/_defineComponent({
  __name: 'LearningSetupSummaryBooksSection',
  props: {
    slugs: {},
    coverUrl: { type: Function }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"summary-books__header\" data-v-0faee4e3><svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-0faee4e3><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.82125 3.72359C9.85132 3.51792 10.1486 3.51792 10.1787 3.72359C10.6392 6.881 13.1189 9.36077 16.2763 9.82125C16.482 9.85132 16.482 10.1486 16.2763 10.1787C13.1189 10.6392 10.6392 13.1189 10.1787 16.2763C10.1486 16.482 9.85132 16.482 9.82125 16.2763C9.36077 13.1189 6.881 10.6392 3.72359 10.1787C3.51792 10.1486 3.51792 9.85132 3.72359 9.82125C6.881 9.36077 9.36077 6.881 9.82125 3.72359Z\" fill=\"#3876F0\" fill-opacity=\"0.5\" data-v-0faee4e3></path></svg><div data-v-0faee4e3><p class=\"summary-books__label\" data-v-0faee4e3>What caught your interest.</p><p class=\"summary-books__desc\" data-v-0faee4e3> We’ll add these books to your Want to Read list. </p></div></div>", 1)),
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.slugs, (slug) => {
        return (_openBlock(), _createElementBlock("li", {
          key: slug,
          class: "summary-books__book"
        }, [
          _createElementVNode("img", {
            src: __props.coverUrl(slug),
            alt: "",
            width: "158",
            height: "211",
            class: "summary-books__cover"
          }, null, 8, _hoisted_3)
        ]))
      }), 128))
    ])
  ]))
}
}

})